import React from 'react'
import { cx } from '@/lib/utils'
import styles from './FormInput.module.scss'

interface FormInputProps {
  id: string
  label: string
  type?: 'text' | 'email'
  value: string
  onChange: (value: string) => void
  placeholder?: string
  error?: string
  required?: boolean
}

export const FormInput: React.FC<FormInputProps> = ({
  id, label, type = 'text', value, onChange, placeholder, error, required = false,
}) => (
  <div className={styles.field}>
    <label className={styles.label} htmlFor={id}>
      {label}
      {required && <span className={styles.required}>*</span>}
    </label>
    <input
      id={id}
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={cx(styles.input, error && styles.inputError)}
      required={required}
    />
    {error && <span className={styles.error}>{error}</span>}
  </div>
)
